import { OPEN_TEXT_SEARCH_EXPERIMENT } from '~/constants/common/openTextSearch';
import { PRICE_DROP_SUPPRESSION_EXPERIMENT } from '~/constants/common/priceDropSuppression';
import { CONDITIONAL_TILES_SUPPRESSION_EXPERIMENT } from '~/constants/srp/conditionalTilesSuppression';
import { SUGGESTED_FILTERS_2ROW_EXPERIMENT } from '~/constants/srp/suggestedFilters2Row';
import type { Experiment } from '~/server-utils/appRouter/fetchExperimentData';

export const clientSideBrowserCookieIdExperiments: Record<string, never> = {};

export const nccLipExperiment: Record<string, Experiment> = {
  'car-merch-ui-srp-ncc-lip4': {}
};

export const mobileOnlyExperiments = {
  [SUGGESTED_FILTERS_2ROW_EXPERIMENT]: { buckets: ['control', 'treatment'] }
};

export const serverSideBrowserCookieIdExperiments = {
  [OPEN_TEXT_SEARCH_EXPERIMENT]: {},
  [PRICE_DROP_SUPPRESSION_EXPERIMENT]: {},
  [CONDITIONAL_TILES_SUPPRESSION_EXPERIMENT]: {}
};

const mobileServerSideBrowserCookieIdExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...mobileOnlyExperiments
};

// Returns stable references so getExperiments' per-request cache hits across the layout and page.
export const getServerSideBrowserCookieIdExperiments = (isMobile: boolean) =>
  isMobile
    ? mobileServerSideBrowserCookieIdExperiments
    : serverSideBrowserCookieIdExperiments;

export const clientSideUserIdExperiments = {};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...nccLipExperiment,
  ...mobileOnlyExperiments,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
